module.exports = __webpack_public_path__ + "static/media/project-NO2.60a88100.jpg";